import React from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';

import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import Layout from './components/Layout/Layout';
import DealersContainer from './containers/Dealers/DealersContainer';
import DealerEditContainer from './containers/Dealers/DealerEditContainer';
import LoginContainer from './containers/Login/LoginContainer';
import DMSContainer from './containers/DMS/DMSContainer';
//import FeaturesContainer from './containers/Features/FeaturesContainer';
import SessionExpired from './components/Login/SessionExpired';
import AppThanks from './containers/Thanks/AppThanks';
import AppRedirectToOSB from './containers/Redirect/AppRedirectToOSB';
//import ReportsContainer from './containers/Reports/ReportsContainer';
import CacheCleanContainer from './containers/CacheClean/CacheCleanContainer';
import PaymentDashboardContainer from './containers/PaymentDashboard/PaymentDashboardContainer';
import PaymentEditContainer from './containers/PaymentDashboard/PaymentEditContainer';
import './base.scss';
import Api from './api/api';


const App = () => {
  Api.getUseRoles();

  return (
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <Router>
        <div>
          <Layout>
            <Route exact path="/" component={DealersContainer} />
            <Route exact path="/login" component={LoginContainer} />
            <Route exact path="/editdealer" component={DealerEditContainer} />
            <Route exact path="/editpayment" component={PaymentEditContainer} />
            <Route exact path="/dms" component={DMSContainer} />
             {/* <Route exact path="/reports" component={ReportsContainer} /> */}
            <Route exact path="/dashboard" component={PaymentDashboardContainer} />
            <Route exact path="/cache" component={CacheCleanContainer} />
            {/* <Route exact path="/features" component={FeaturesContainer} /> */}
            <Route exact path="/sessionexpired" component={SessionExpired} />
            <Route exact path="/thanks" component={AppThanks} />
            <Route exact path="/redirectToOSB" component={AppRedirectToOSB} />
          </Layout>
        </div>
      </Router>
    </MuiPickersUtilsProvider>
  );
};

export default App;



// WEBPACK FOOTER //
// ./src/App.js